import React, { createContext, useContext, useEffect, useState } from "react";
import { AuthContext } from "./auth";

export const ExpiringContext = createContext();

export default function ExpiringContextProvider({ children }) {
  // setting the current date
  const todaysDate = new Date();

  // Getting the authorize user
  const { authorizeUserData } = useContext(AuthContext);

  // States
  const [bookingsToExpire, setBookingsToExpire] = useState();
  const [loading, setLoading] = useState(true);
  const [expireCheckComplete, setExpireCheckComplete] = useState(false);

  // Getting the Active Bookings from the Database
  const getActiveBookings = async () => {
    try {
      let response;
      if (authorizeUserData?.is_Admin) {
        response = await fetch(
          `https://hotelbnb-backend.onrender.com/read-active-bookings`
        );
      } else if (!authorizeUserData?.is_Admin) {
        response = await fetch(
          `https://hotelbnb-backend.onrender.com/read-active-bookings/${authorizeUserData?.user_email}`
        );
      }
      if (response.ok) {
        const result = await response.json();
        if (result.length > 0) {
          const filteredBookings = result.filter((booking) => {
            const expiryDate = new Date(booking.booking_to.split("T")[0]);
            const exactExpiryTime = new Date(
              expiryDate.getFullYear(),
              expiryDate.getMonth(),
              expiryDate.getDate(),
              23,
              11,
              59,
              59,
              999
            );
            const isBookingExpired = todaysDate > exactExpiryTime;
            if (isBookingExpired) {
              return booking;
            }
          });
          setBookingsToExpire(filteredBookings);
          setLoading(false);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const expireAllBookings = async () => {
    const response = await fetch(`https://hotelbnb-backend.onrender.com/expiring-booking`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ bookingsToExpire: bookingsToExpire }),
    });

    if (response.ok) {
      setExpireCheckComplete(true);
    }
  };

  // Checking if booking data that has to be expired is set and loading is false so we can update
  const checkBookingDataToExpire = () => {
    if (!loading && bookingsToExpire.length) {
      expireAllBookings();
    }
  };

  useEffect(() => {
    getActiveBookings();
  }, [authorizeUserData]);

  useEffect(() => {
    checkBookingDataToExpire();
  }, [bookingsToExpire]);

  return (
    <ExpiringContext.Provider value={expireCheckComplete}>
      {children}
    </ExpiringContext.Provider>
  );
}
